export enum ActionType {
    COACHING_DETAIL__TS__RELOAD = 'COACHING_DETAIL__TS__RELOAD',
    COACHING_DETAIL__TS__RELOAD_RESULT = 'COACHING_DETAIL__TS__RELOAD_RESULT',
    COACHING_DETAIL__TS__CREATE_CALL = 'COACHING_DETAIL__TS__CREATE_CALL',
    COACHING_DETAIL__TS__CREATE_CALL_RESULT = 'COACHING_DETAIL__TS__CREATE_CALL_RESULT',
    COACHING_DETAIL__TS__DELETE_TRANSCRIPT = 'COACHING_DETAIL__TS__DELETE_TRANSCRIPT',
    COACHING_DETAIL__TS__DELETE_TRANSCRIPT_RESULT = 'COACHING_DETAIL__TS__DELETE_TRANSCRIPT_RESULT',
    COACHING_DETAIL__TS__FILTER_SUMMARY = 'COACHING_DETAIL__TS__FILTER_SUMMARY',
    COACHING_DETAIL__TS__SORT_SUMMARY = 'COACHING_DETAIL__TS__SORT_SUMMARY',
    COACHING_DETAIL__TS__TOGGLE_CATEGORY = 'COACHING_DETAIL__TS__TOGGLE_CATEGORY',
    COACHING_DETAIL__TS__TOGGLE_CATEGORY_TRANSCRIPT = 'COACHING_DETAIL__TS__TOGGLE_CATEGORY_TRANSCRIPT',
}
